export default __webpack_public_path__ + "static/Plots0098-33a1df8b866e0fc46c775a3c58c1f416.jpg";